<!--

Component is used when navigation is needed. Style of the button can be modified in multiple options. Check slots and props below for details.

Slots:
  - default : Anything you provide in the component body will be shown inside "button-content" slot instead the default provided in the component.
              You can pass complex HTML structure if needed.

Props:
  -

-->

<template>
  <b-dropdown
    no-caret
    right
    no-flip
    toggle-class="dropdown-menu-toggle"
    menu-class="menu-items offset-down"
    class="sb-dropdown-menu business-menu"
    :class="{'auto-width': autoWidth, 'auto-height': autoHeight, 'no-hover-box': noHover}"
    @click.native.stop="">
    <!-- Button content -->
    <template slot="button-content">
      <slot>
        <template v-if="location">
          <span :class="`left-icon icon ${location.toLowerCase()}`"/>
          <span
            v-if="location"
            class="location">{{ location }}</span>
          <span class="right-icon icon arrow down"/>
        </template>
        <span
          v-else
          class="sb-dropdown-menu-button"/>
      </slot>


      <!-- TODO Check if this is needed -->
      <!-- <span
        v-if="buttonStyle === BusinessDropdownTypes.ICON"
        class="sb-dropdown-menu-button"/>
      <span v-else-if="buttonStyle === BusinessDropdownTypes.NAVIGATION">
        TEST BUTTON VALUE
      </span> -->

    </template>
    <!-- Header on the menu items -->
    <b-dropdown-header>
      <span
        v-if="showMerchantLogo"
        class="logo"
        :style="merchant.logo ? `background-image: url(${merchant.logo});` : ''"/>
      <span
        class="data">
        <p class="title">{{ merchant.name }}</p>
        <div class="availability">
          <SwitchCheckbox
            :id="merchant.name + 'AvailabilitySwitch'"
            :value="isAvailable"
            class="dropdown-check"
            size="micro"
            outline-color="#B2ECE4"
            switch-color="#00bfa5"
            off-outline-color="#ffcdcf"
            off-switch-color="#ff5b61"
            @input="changeMerchantAvailability"/>
          <span
            :class="isAvailable ? '' : 'unavailable'">{{ isAvailable ? 'Available' : 'Away' }}</span>
        </div>
      </span>
    </b-dropdown-header>
    <b-dropdown-divider/>
    <b-dropdown-item
      :to="{ name: 'Merchant', params: { merchant_id: merchant.id }}"
      @click.native="setMerchantPartialData(merchant)">
      <span class="icon inbox"/>
      <span class="text">Inbox</span>
    </b-dropdown-item>
    <b-dropdown-divider/>
    <b-dropdown-item>
      <span class="icon broadcasts"/>
      <span class="text">Broadcasts *</span>
    </b-dropdown-item>
    <b-dropdown-divider/>
    <b-dropdown-item
      :to="{ name: 'Automation', params: { merchant_id: merchant.id}}"
      @click.native="setMerchantPartialData(merchant)">
      <span class="icon automation"/>
      <span class="text">Automation</span>
    </b-dropdown-item>
    <b-dropdown-divider/>
    <b-dropdown-item
      :to="{ name: 'Contacts', params: { merchant_id: merchant.id}}"
      @click.native="setMerchantPartialData(merchant)">
      <span class="icon contacts"/>
      <span class="text">Contacts</span>
    </b-dropdown-item>
    <b-dropdown-divider/>
    <b-dropdown-item>
      <span class="icon sources"/>
      <span class="text">Sources *</span>
    </b-dropdown-item>
    <b-dropdown-divider/>
    <b-dropdown-item
      :to="{ name: 'Analytics', params: { merchant_id: merchant.id}}"
      @click.native="setMerchantPartialData(merchant)">
      <span class="icon analytics"/>
      <span class="text">Analytics</span>
    </b-dropdown-item>
    <b-dropdown-divider/>
    <b-dropdown-item>
      <span class="icon integrations"/>
      <span class="text">Integrations *</span>
    </b-dropdown-item>
    <b-dropdown-divider/>
    <b-dropdown-item>
      <span class="icon developers"/>
      <span class="text">Developers *</span>
    </b-dropdown-item>
    <b-dropdown-divider/>
    <b-dropdown-item
      :to="{ name: 'BusinessSettings', params: { merchant_id: merchant.id}}"
      @click.native="setMerchantPartialData(merchant)">
      <span class="icon settings"/>
      <span class="text">Settings</span>
    </b-dropdown-item>
    <b-dropdown-divider/>
    <!-- Footer on the menu items -->
    <b-dropdown-text class="sb-dropdown-menu-footer">
      Need help? Chat with us.
    </b-dropdown-text>
  </b-dropdown>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import MerchantAvailabilityMixin from '@/mixins/MerchantAvailability';
import SwitchCheckbox from '../common/SwitchCheckbox';
import BusinessDropdownTypes from '../../helpers/lists/businessDropdownTypes';

export default {
  name: 'BusinessDropdown',
  components: {
    SwitchCheckbox,
  },
  mixins: [MerchantAvailabilityMixin],
  props: {
    /**
     * Merchant for which the button is generated.
     * Check model - src/models/Merchant.json TODO
     */
    merchant: {
      type: Object,
      required: true,
    },
    /**
     * Defines location to be shown on the business dropdown button.
     * If provided it will force the location on the button.
     */
    location: {
      type: String,
      required: false,
      default: null,
    },
    /**
     * Flag for showing merchant logo on the dropdown header.
     */
    showMerchantLogo: {
      type: Boolean,
      required: false,
      default: true,
    },
    /**
     * Button is by default restricted to a 40px square. This param will make the with addoptable to content.
     * TODO... see if this can be achieved with css only for the default tridots button.
     */
    autoWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Unlocks height to be addoptable to content.
     */
    autoHeight: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * There is a default hover state on the button. It can be toggled with this prop.
     */
    noHover: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * TODO see if it will be needed or not...
     */
    buttonStyle: {
      type: String,
      default: BusinessDropdownTypes.ICON,
    },
  },
  data() {
    return {
      BusinessDropdownTypes,
    };
  },
  computed: {
    ...mapGetters({
      merchantAvailability: 'merchant/merchantAvailability',
    }),
    isAvailable() {
      return this.merchantAvailability[this.merchant.id];
    },
  },
  methods: {
    ...mapActions({
      setMerchantPartialData: 'merchant/setMerchantPartialData',
    }),
  },
};
</script>

<style lang="scss" scoped>
.business-menu {
  width: 32px !important;
  height: 18px !important;
  margin-right: 5px!important;

  &.auto-width {
    width: auto !important;
  }

  &.auto-height {
    height: auto !important;
  }

  .location {
    font-size: 16px;
    font-weight: 500;
  }

  .left-icon {
    margin-right: 8px !important;
  }

  .right-icon {
    width: 11px !important;
    height: 6px !important;
    margin-left: 8px !important;
    margin-right: 0 !important;
  }

  ::v-deep .dropdown-menu-toggle {
    box-shadow: none !important;
  }
}
</style>
